const validations = {
  mustBeNumber: "This field must be a number",
  mustBePositive: "This field must be a positive number",
  required: "This field is required",
  mustBeEmail: "This field must be a valid email",
  mustBeDate: "This field must be a valid date",
};

export default validations;
